import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	enableWidgetToggleLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.enable-widget-toggle-label',
		defaultMessage: 'Enable widget',
		description:
			'Label for the enable widget toggle, which enables or disables the loading of the widget in the page where it is embedded',
	},
	defaultRequestTypeSelectLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.default-request-type-select-label',
		defaultMessage: 'Default request type',
		description:
			'Label for the default request type select, which allows the user to select the default request type to be displayed in the widget',
	},
	defaultRequestTypeSelectHelpText: {
		id: 'servicedesk-widget-settings.content.settings-form.default-request-type-select-help-text',
		defaultMessage:
			'The default request type allows customers to contact you even if nothing matches their search results',
		description:
			'Help text for the default request type select, explaining what the default request type is for',
	},
	allowSearchForAllRequestTypesToggleLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.allow-search-for-all-request-types-toggle-label',
		defaultMessage: 'Allow search for all request types',
		description:
			'Label for the allow search for all request types toggle, which allows the user to search for all request types',
	},
	allowSearchForKnowledgeBaseArticlesToggleLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.allow-search-for-knowledge-base-articles-toggle-label',
		defaultMessage: 'Allow search for knowledge base articles',
		description:
			'Label for the allow search for knowledge base articles toggle, which allows the user to search for knowledge base articles',
	},
	allowSearchForKnowledgeBaseArticlesToggleHelpText: {
		id: 'servicedesk-widget-settings.content.settings-form.allow-search-for-knowledge-base-articles-toggle-help-text',
		defaultMessage: "Make sure 'Viewing' access is set to 'Anyone' in knowledge base settings",
		description:
			'Help text for the allow search for knowledge base articles toggle, explaining what the user needs to do to enable this feature',
	},
	colorInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.color-input-label',
		defaultMessage: 'Color',
		description:
			'Label for the color input, which allows the user to select the theme color of the widget',
	},
	colorInputErrorMessage: {
		id: 'servicedesk-widget-settings.content.settings-form.color-input-error-message',
		defaultMessage: 'Invalid color code',
		description:
			'Error message for the color input, displayed when the user enters an invalid color code which is not a valid hex color',
	},
	widgetBackgroundPatternSelectLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.widget-background-pattern-select-label',
		defaultMessage: 'Widget background pattern',
		description:
			'Label for the widget background pattern select, which allows the user to select the background pattern of the widget from a list of available patterns',
	},
	widgetButtonTypeRadioGroupLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.widget-button-type-radio-group-label',
		defaultMessage: 'Widget button type',
		description:
			'Label for the widget button type radio group, which allows the user to select the type of button to be displayed in the widget. The available options are: question mark icon, custom text. Selecting custom text enables the custom text input',
	},
	widgetButtonQuestionMarkIconRadioLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.widget-button-question-mark-icon-radio-label',
		defaultMessage: 'Question mark icon',
		description:
			'Label for the widget button question mark icon radio option, which displays a question mark icon in the widget button',
	},
	widgetButtonCustomTextRadioLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.widget-button-custom-text-radio-label',
		defaultMessage: 'Custom button text',
		description:
			'Label for the widget button custom text input which is displayed when selecting the custom text radio option, which allows the user to enter custom text to be displayed in the widget button',
	},
	widgetButtonCustomTextInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.widget-button-custom-text-input-label',
		defaultMessage: 'Custom text',
		description:
			'Label for the widget button custom text input, which allows the user to enter custom text to be displayed in the widget button',
	},
	widgetHeaderInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.widget-header-input-label',
		defaultMessage: 'Widget header',
		description:
			'Label for the widget header input, which allows the user to enter a custom header to be displayed in the title of the widget',
	},
	confirmationMessageInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.confirmation-message-input-label',
		defaultMessage: 'Confirmation message',
		description:
			'Label for the confirmation message input, which allows the user to enter a custom confirmation message to be displayed after the user submits a request',
	},
	saveButtonLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.save-button-label',
		defaultMessage: 'Save',
		description:
			'Label for the save button, which saves the widget settings and shows the embed code section',
	},
	cancelButtonLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.cancel-button-label',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button, which cancels the widget settings and resets the form to last saved values',
	},
	errorBlankValue: {
		id: 'servicedesk-widget-settings.content.settings-form.error-blank-value',
		defaultMessage: 'Add a {fieldName}',
		description:
			'Error message for blank value, displayed when the user leaves a required field blank. Used for all required text input fields',
	},
	errorMaxLength: {
		id: 'servicedesk-widget-settings.content.settings-form.error-max-length',
		defaultMessage: "{fieldName} can't exceed {length} characters.",
		description:
			'Error message for maximum length exceeded, displayed when the user enters a value which exceeds the maximum length allowed for a field',
	},
	errorFetchingRequestTypes: {
		id: 'servicedesk-widget-settings.content.settings-form.error-fetching-request-types',
		defaultMessage: "We can't load the request types right now. Try again in a little while.",
		description:
			'Error message displayed when there is an error fetching request types from the backend',
	},
	formAriaLabel: {
		id: 'servicedesk-widget-settings.content.settings-form.form-aria-label',
		defaultMessage:
			'The changes you make in the form input fields will be reflected in the Preview',
		description:
			'Aria label for the widget settings form, which is used to describe the form to screen readers',
	},
});
